export default {
  get isAppleMobile() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent)
  },
  get isAppleDevice() {
    return this.isAppleMobile || (navigator.vendor && navigator.vendor.indexOf('Apple') > -1)
  },
  get isMacintosh() {
    return navigator.platform.indexOf('Mac') > -1
  },
  get existsAppleSession() {
    return !!window.ApplePaySession
  },
  get isIosGreaterThan14() {
    const iOSVersionMatch = navigator.userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/)
    let version = 0
    if (iOSVersionMatch) {
      version = parseInt(iOSVersionMatch[1], 10)
    }
    return version > 14
  }
}
